module.exports = __webpack_public_path__ + "img/brand.b444b879.png";